import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import getComponentFromProps from '@elliemae/ds-utilities/getComponentFromProps';
import DSTextWrapper from '@elliemae/ds-text-wrapper';
import { ResizeObserver } from 'resize-observer';
import getSvgPath from './getSvgPath.js';
import RequiredMark from '../RequiredMark/RequiredMark.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'labeled-outline';
var Wrapper = aggregatedClasses('div')(blockName, null, function (_ref) {
  var isOpen = _ref.isOpen;
  return {
    'has-value': isOpen
  };
});
var FloatingLabel = aggregatedClasses('label')(blockName, 'label');
var OutlineIdle = aggregatedClasses('div')(blockName, 'idle');
var Outline = aggregatedClasses('div')(blockName, 'outline');
var OutlinePath = aggregatedClasses('path')(blockName, 'outline__path');

var shouldUpdateSvgPath = function shouldUpdateSvgPath(_ref2, prevSizes) {
  var width = _ref2.width,
      height = _ref2.height,
      labelWidth = _ref2.labelWidth;
  if (width !== prevSizes.width) return true;
  if (height !== prevSizes.height) return true;
  return labelWidth !== prevSizes.labelWidth;
};

var FloatingLabelInputImpl = /*#__PURE__*/function (_Component) {
  _inherits(FloatingLabelInputImpl, _Component);

  var _super = _createSuper(FloatingLabelInputImpl);

  function FloatingLabelInputImpl(props) {
    var _this;

    _classCallCheck(this, FloatingLabelInputImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resizeObserver", new ResizeObserver(function () {
      return _this.updatePath();
    }));

    _defineProperty(_assertThisInitialized(_this), "prevSizes", {});

    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.outlinePathRef = /*#__PURE__*/React.createRef();
    _this.outlineIdleRef = /*#__PURE__*/React.createRef();
    _this.labelRef = /*#__PURE__*/React.createRef();
    _this.updatePath = _this.updatePath.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FloatingLabelInputImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeObserver.observe(this.wrapperRef.current);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!shouldUpdateSvgPath(this.sizes, this.prevSizes)) return;
      this.updatePath();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.unobserve(this.wrapperRef.current);
    }
  }, {
    key: "sizes",
    get: function get() {
      var labelEl = this.labelRef.current;
      var wrapperEl = this.wrapperRef.current;
      var outlineIdleEl = this.outlineIdleRef.current;
      var elStyles = window.getComputedStyle(outlineIdleEl);
      var leftRadius = elStyles.getPropertyValue('border-top-left-radius');
      var rightRadius = elStyles.getPropertyValue('border-top-right-radius');
      var hasLeftRadius = parseFloat(leftRadius) !== 0;
      var hasRightRadius = parseFloat(rightRadius) !== 0;
      return {
        labelWidth: labelEl.offsetWidth * 0.9,
        width: wrapperEl.offsetWidth,
        height: wrapperEl.offsetHeight,
        radiusStyle: leftRadius,
        hasLeftRadius: hasLeftRadius,
        hasRightRadius: hasRightRadius
      };
    }
  }, {
    key: "isOpened",
    get: function get() {
      var _this$props = this.props,
          focused = _this$props.focused,
          isOpen = _this$props.isOpen,
          value = _this$props.value;
      return focused || (Array.isArray(value) ? !!value.length : !!value) || isOpen;
    }
  }, {
    key: "getValue",
    value: function getValue(value) {
      var valueAccessor = this.props.valueAccessor;
      if (valueAccessor) return valueAccessor(value); // is an event

      if (value && value.target) return value.target.value;
      return value;
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var path = getSvgPath(this.sizes);
      this.prevSizes = this.sizes;
      this.outlinePathRef.current.setAttribute('d', path);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ariaLabel = _this$props2.ariaLabel,
          hasError = _this$props2.hasError,
          readOnly = _this$props2.readOnly,
          disabled = _this$props2.disabled,
          inputComponent = _this$props2.inputComponent,
          labelText = _this$props2.labelText,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          innerRef = _this$props2.innerRef,
          extraInputProps = _this$props2.extraInputProps,
          required = _this$props2.required,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          mask = _this$props2.mask,
          useSubfix = _this$props2.useSubfix,
          optional = _this$props2.optional;

      var inputProps = _objectSpread({
        ariaLabel: ariaLabel,
        className: 'floating-label-input-controller',
        disabled: disabled,
        hasError: hasError,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        readOnly: readOnly,
        value: value,
        innerRef: innerRef,
        mask: mask,
        useSubfix: useSubfix
      }, extraInputProps);

      var InputComponent = getComponentFromProps(inputComponent, inputProps);
      var isOpen = this.isOpened;
      return /*#__PURE__*/React.createElement(Wrapper, {
        classProps: {
          hasError: hasError,
          isOpen: isOpen,
          readOnly: readOnly,
          disabled: disabled
        },
        innerRef: this.wrapperRef,
        onBlur: function onBlur() {
          return null;
        },
        onFocus: function onFocus() {
          return null;
        },
        onMouseOut: this.handleMouseOut,
        onMouseOver: this.handleMouseOver
      }, InputComponent, /*#__PURE__*/React.createElement(FloatingLabel, {
        classProps: {
          isOpen: isOpen
        },
        innerRef: this.labelRef
      }, /*#__PURE__*/React.createElement(DSTextWrapper, {
        maxWidth: "100%",
        text: labelText
      }), /*#__PURE__*/React.createElement(RequiredMark, {
        optional: optional,
        required: required
      })), /*#__PURE__*/React.createElement(Outline, null, /*#__PURE__*/React.createElement("svg", null, /*#__PURE__*/React.createElement(OutlinePath, {
        innerRef: this.outlinePathRef
      }))), /*#__PURE__*/React.createElement(OutlineIdle, {
        innerRef: this.outlineIdleRef
      }));
    }
  }]);

  return FloatingLabelInputImpl;
}(Component);

_defineProperty(FloatingLabelInputImpl, "defaultProps", {
  onChange: function onChange() {
    return null;
  }
});

export default FloatingLabelInputImpl;
//# sourceMappingURL=FloatingLabelInputImpl.js.map
